
import styled from 'styled-components';
import COLORS from '@mlb/react-patterns/v4/style/universal.color.ts';
import Table from '@mlb/react-patterns/v4/components/Table/table';
import Link from '@mlb/react-patterns/v4/components/Link/link';
import { StyledTableCell } from '@mlb/react-patterns/v4/components/Table/TableCell/table-cell.style';
import { StyledTable, TableScroller} from '@mlb/react-patterns/v4/components/Table/table.style';
import { StyledButton, Label as ButtonLabel } from '@mlb/react-patterns/v4/components/Button/button.style'
import { GDBREAKPOINTS_NUM } from '@gameday/components/themes/breakpoints';
import Card from '../Card/Card';
import { CardWrapper } from '../Card/Card.style';

const {
    MD,
    LG
} = GDBREAKPOINTS_NUM;

const mobileWidth = MD - 1 + 'px';

const {
    mlbGrey4
} = COLORS;

const headerWidth = '124px';

export const CustomHeadCellContainer = styled.div`
    display: flex;    
    font-weight: 700;
    font-size: 12px;
    line-height: 12px;
    color: var(--gameday-primary-font-color);
    height: 15px;

    span {
        margin-top: 1px;
        font-size: 10px;
        margin-right: 3px;
        line-height: 12px;
        width: auto !important;
    }

    div {
        margin-right: 3px;
    }
`;

export const PlayerWrapper = styled.div`
    margin-right: 3px;
    text-transform: none;
`

export const ErrorWrapper = styled.div`
    height: 359px;
    font-weight: 700;
    font-size: 12px;
    line-height: 12px;
    color: var(--gameday-secondary-font-color);
    
    @media only screen and (max-width: ${mobileWidth}) {
        height: 32px;
    }    
`; 

export const LineupTableWrapper = styled.div`
    
    font-family: var(--gameday-primary-font);
    width: 100%;
    min-height: 370px;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 12px;
    padding: 0;
    
    &.error {
        min-height: auto;
        ${StyledTableCell} {
            vertical-align: top;
            height: 0;
        }
        
        ${StyledTable} {
            height: auto;
        }

        ${TableScroller} {
            height: 30px;
        }
    }
`;

export const LineupTable = styled(Table)`
    width: 100%;
    font-feature-settings: "tnum";
    font-variant-numeric: tabular-nums lining-nums;
    border-collapse: separate;
    border-spacing: 0px;
    padding-bottom: 0;
    &.matchup {
        height: auto;
    }

    thead {
        th {
            text-transform: uppercase;
            border-bottom: 1px solid var(--gameday-divider-color);
            font-style: normal;
            font-weight: 700;
            font-size: 12px;
            padding: 6px 6px 12px;
            &:first-child{
                color: var(--gameday-primary-font-color);
                padding-left: 0; 
                max-width: ${headerWidth};
                span {
                    height: 15px;
                    display: inline-block;
                    text-transform: none;
                }
            }
            color: var(--gameday-secondary-font-color)};
        }
    }

    tbody {
        ::before {
            height: 0px;
        }
        tr {
            td {
                padding-top: 24px;
                padding-bottom: 0;
            }
        }
        ${StyledTableCell} {
            height: 12px;
            border-radius: 0;
            font-weight: 500;
            font-size: 12px;
            &:first-child{
                padding-left:0;
                max-width: ${headerWidth}
            }
            color: var(--gameady-primary-font-color);
        }
    }
`;

export const TabsWrapper = styled.div`
    ${StyledButton} {
        font-family: var(--gameday-primary-font);
        font-weight: 800;
        font-size: 20px;
        line-height: 20px;
        color: var(--gameday-primary-font-color);
        height: 20px;
        margin-top: 0;
        &:not([data-selected=true]){
            font-weight: 700;
        }
    }

    > div:first-of-type  {
        margin: 0 0 16px 4px;
        height: 20px;


        > div {
            padding-bottom: 12px;
        }
    }

`;

export const StyledCard = styled(Card)`
    @media only screen and (max-width: ${mobileWidth}) {
        flex-direction: column;
        margin-left: 0;
        margin-right: 0;
        margin-top: 0;
        overflow: hidden;
        max-height: none;
        > div  {
            margin-left: 0;
            &:first-of-type  {
                margin-bottom: 26px; 
                .info {
                    display: none;
                }
            }
        }
    }
`;

export const DesktopWrapper = styled.div`
    display: flex;
    justify-content: stretch;

    ${StyledTable} {
        width: 100%;
    }

    ${CardWrapper} {
        flex-grow: 1;
        width: 100%;
        margin-top: 0;
        flex-grow: 1;  
        > div:first-of-type  {
            margin-right: 16px;
        }
    }

    ${StyledCard} {
        overflow-x: hidden;
        &:first-child {
            margin-left:0 !important;
        }

        &:last-child {
            margin-right:0 !important;
        }
    }
`;



export const InnerWrapper = styled.span`
    font-size: 12px;
    line-height: 12px;
    font-weight: 700;
    max-width:70%;
    overflow: hidden;
    text-overflow: ellipsis;
    a {
        color: var(--gameday-primary-font-color);
    }
`;

export const PositionWrapper = styled(InnerWrapper)`
    color: var(--gameday-secondary-font-color);
    margin-left: 6px;
    font-weight: 500;
    font-size: 11px;
`;

export const OrderWrapper = styled(InnerWrapper)`
    color: var(--gameday-secondary-font-color);
    margin-right: 6px;
`;

export const PlayerLink = styled(Link)`
    text-decoration:none;
    color: var(--gameday-primary-font-color);
    &:hover {
        color: var(--gameday-link-color) !important;
    }
`;

export const CustomPlayerCellContainer = styled.div`
    display: inline-block;
    height: 12px;
    span {
        width: auto !important;
    }
`;

export const LineupTextwrapper = styled.div`
    font-weight: 700;
    font-size: 12px;
    line-height: 12px;
    color: var(--gameday-secondary-font-color);
    margin-top: 16px;
`;

